var Base = require('_js/base'),
  ko = require('knockout'),
  $ = require('jquery');

function model() {}

function MarketingTeaserTile() {
  this.init();
}
function applyBindingsForElement() {
  ko.applyBindings(
    new model({
      element: $(this).data('marketing-teaser-tile')
    }),
    this
  );
}
MarketingTeaserTile.prototype = new Base();

MarketingTeaserTile.prototype.init = function() {
  var $marketingTeaserTile = $('[data-marketing-teaser-tile]');
  $marketingTeaserTile.each(applyBindingsForElement);
};

module.exports = MarketingTeaserTile;
